import './DashboardCard.css';
import dayjs from 'dayjs';
const CurrentDispatchCard = ({ colSpan = 2, rowSpan = 1, dashboardData = {} }) => {
  const { drHistoryLatestData } = dashboardData;

  // date는 "20260122" 형식의 문자열이므로 YYYYMMDD 형식으로 파싱
  const dateStr = drHistoryLatestData?.date;
  const startTimeStr = drHistoryLatestData?.startTime; // "10:00"
  const endTimeStr = drHistoryLatestData?.endTime; // "11:00"
  
  // "20260122 10:00" 형식으로 조합하여 dayjs 객체 생성
  const startTime = dateStr && startTimeStr ? dayjs(`${dateStr} ${startTimeStr}`, 'YYYYMMDD HH:mm') : null;
  const endTime = dateStr && endTimeStr ? dayjs(`${dateStr} ${endTimeStr}`, 'YYYYMMDD HH:mm') : null;
  
  // 현재 시각이 시작 시간과 종료 시간 사이에 있는지 확인
  const now = dayjs();
  const isDrWorking = startTime && endTime && now.isAfter(startTime) && now.isBefore(endTime);
  const isDrReady = startTime && endTime && now.isBefore(startTime);
  return (
    <div 
      className="dashboard-card dispatch-card flex flex-col justify-between" 
    >
      <div className="dashboard-card-content flex flex-col gap-5">
        <div>
          {isDrWorking ? (
            <div className='dashboard-dr-working-info working'>
              DR 발령중
            </div>
          ) : 
          isDrReady ? (
            <div className='dashboard-dr-working-info scheduled'>
              DR 발령 예정
            </div>
          ) : (
            <div className='dashboard-dr-working-info not-working'>
              DR 발령 없음
            </div>
          )}
        </div>
        {
          isDrWorking || isDrReady ? (
            <>
              <div className='flex gap-5'>
                <p className="text-b1-700 text-gray-700">시작 {startTime?.format('YYYY년 MM월 DD일')} {startTimeStr}</p>
              </div>
              <div className='flex gap-5'>
                <p className="text-b1-700 text-gray-600">종료 {endTime?.format('YYYY년 MM월 DD일')} {endTimeStr}</p>
              </div>
            </>
          ): (
            // 발령 정보 없음
            <div className='flex gap-5 my-10'>
              <p className="text-b1-700 text-gray-600">발령 정보 없음</p>
            </div>
          )
        }

      </div>
    </div>
  );
};

export default CurrentDispatchCard;
